import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "../layout/AppShell";
import { PortalShell } from "../layout/PortalShell";
import { ProtectedRoute } from "../auth/ProtectedRoute";
import { PortalProtectedRoute } from "../auth/PortalProtectedRoute";
import { RoleGuard } from "../auth/RoleGuard";
import { useAuth } from "../auth/AuthContext";
import { landingPathFor } from "../layout/navConfig";
import StaffLogin from "../pages/auth/StaffLogin";
import DashboardPage from "../pages/dashboard/DashboardPage";
import ApplicationsPage from "../pages/applications/ApplicationsPage";
import CustomersPage from "../pages/customers/CustomersPage";
import ContractsPage from "../pages/contracts/ContractsPage";
import SettlementTypesPage from "../pages/settlement-types/SettlementTypesPage";
import SkillLevelsPage from "../pages/skill-levels/SkillLevelsPage";
import QuotesPage from "../pages/quotes/QuotesPage";
import ReceivablesPage from "../pages/receivables/ReceivablesPage";
import PayablesPage from "../pages/payables/PayablesPage";
import ReportsPage from "../pages/reports/ReportsPage";
import SettingsPage from "../pages/settings/SettingsPage";
import UsersPage from "../pages/users/UsersPage";
import AuditLogsPage from "../pages/audit/AuditLogsPage";
import PortalLogin from "../pages/portal/PortalLogin";
import PortalFirstAccess from "../pages/portal/PortalFirstAccess";
import PortalForgotPassword from "../pages/portal/PortalForgotPassword";
import PortalResetPassword from "../pages/portal/PortalResetPassword";
import PortalDashboard from "../pages/portal/PortalDashboard";

/** "/app" tenta o Painel; papéis sem acesso ao dashboard (ex.: Suporte) caem na primeira tela
 * que o papel de fato enxerga, em vez de um 403 seco na porta de entrada. */
function DashboardOrLanding() {
  const { user } = useAuth();
  if (user && !["ADMIN", "FINANCEIRO", "LEITURA"].includes(user.role)) {
    return <Navigate to={landingPathFor(user.role)} replace />;
  }
  return <DashboardPage />;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<StaffLogin />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<AppShell />}>
          <Route index element={<DashboardOrLanding />} />
          <Route
            path="aplicacoes"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <ApplicationsPage />
              </RoleGuard>
            }
          />
          <Route
            path="clientes"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO", "SUPORTE"]}>
                <CustomersPage />
              </RoleGuard>
            }
          />
          <Route
            path="contratos"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <ContractsPage />
              </RoleGuard>
            }
          />
          <Route
            path="tipos-de-baixa"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <SettlementTypesPage />
              </RoleGuard>
            }
          />
          <Route
            path="niveis-habilidade"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <SkillLevelsPage />
              </RoleGuard>
            }
          />
          <Route
            path="orcamentos"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <QuotesPage />
              </RoleGuard>
            }
          />
          <Route
            path="receber"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <ReceivablesPage />
              </RoleGuard>
            }
          />
          <Route
            path="pagar"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO"]}>
                <PayablesPage />
              </RoleGuard>
            }
          />
          <Route
            path="relatorios"
            element={
              <RoleGuard allow={["ADMIN", "FINANCEIRO", "LEITURA"]}>
                <ReportsPage />
              </RoleGuard>
            }
          />
          <Route
            path="configuracoes"
            element={
              <RoleGuard allow={["ADMIN"]}>
                <SettingsPage />
              </RoleGuard>
            }
          />
          <Route
            path="usuarios"
            element={
              <RoleGuard allow={["ADMIN"]}>
                <UsersPage />
              </RoleGuard>
            }
          />
          <Route
            path="auditoria"
            element={
              <RoleGuard allow={["ADMIN"]}>
                <AuditLogsPage />
              </RoleGuard>
            }
          />
        </Route>
      </Route>

      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/primeiro-acesso" element={<PortalFirstAccess />} />
      <Route path="/portal/esqueci-senha" element={<PortalForgotPassword />} />
      <Route path="/portal/redefinir-senha" element={<PortalResetPassword />} />

      <Route element={<PortalProtectedRoute />}>
        <Route path="/portal" element={<PortalShell />}>
          <Route index element={<PortalDashboard />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
